import { render, staticRenderFns } from "./PlatformModal.vue?vue&type=template&id=1a96cc0b&scoped=true"
import script from "./PlatformModal.vue?vue&type=script&lang=ts"
export * from "./PlatformModal.vue?vue&type=script&lang=ts"
import style0 from "./PlatformModal.vue?vue&type=style&index=0&id=1a96cc0b&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a96cc0b",
  null
  
)

export default component.exports